module.exports = __webpack_public_path__ + "img/tianmao.47c16255.webp";